import { Paper } from "@mui/material";
import { CustomWorkDetailFieldsFragment } from "generated-graphql/graphql";

import { WorkDocumentsPanel } from "./WorkDocumentsPanel";
import { WorkHistoryPanel } from "./WorkHistoryPanel";
import { WorkStepsList, WorkStep } from "./WorkStepsList";

export type DetailTab = "steps" | "documents" | "history";

type WorkDetailTabPanelsProps = {
  tab: DetailTab;
  detail: CustomWorkDetailFieldsFragment;
  canEdit: boolean;
  busy: boolean;
  onStart: (activityId: string) => void;
  onComplete: (activityId: string) => void;
  onSkip: (activityId: string) => void;
  onAssign: (activityId: string) => void;
  onReopen: (activityId: string) => void;
  onAttachDocument: (step?: WorkStep) => void;
  onOpenDocument: (documentId: string) => void;
  onDetachDocument: (documentId: string) => void;
  onAddStep: (description: string) => Promise<boolean>;
};

/** Body of the selected tab. Only one is mounted at a time. */
export function WorkDetailTabPanels({
  tab,
  detail,
  canEdit,
  busy,
  onStart,
  onComplete,
  onSkip,
  onAssign,
  onReopen,
  onAttachDocument,
  onOpenDocument,
  onDetachDocument,
  onAddStep,
}: WorkDetailTabPanelsProps) {
  if (tab === "steps") {
    return (
      <Paper variant="outlined" sx={{ p: 2.5 }}>
        <WorkStepsList
          steps={detail.steps}
          canEdit={canEdit}
          busy={busy}
          onStart={onStart}
          onComplete={onComplete}
          onSkip={onSkip}
          onAssign={onAssign}
          onReopen={onReopen}
          onAttachDocument={onAttachDocument}
          onOpenDocument={onOpenDocument}
          onAddStep={onAddStep}
        />
      </Paper>
    );
  }

  if (tab === "documents") {
    return (
      <WorkDocumentsPanel
        documents={detail.documents}
        canEdit={canEdit}
        onAddDocument={() => onAttachDocument()}
        onDetach={onDetachDocument}
      />
    );
  }

  return <WorkHistoryPanel history={detail.history} />;
}
